import { render, staticRenderFns } from "./ShareSavingsReport.vue?vue&type=template&id=9530fb8c&"
import script from "./ShareSavingsReport.vue?vue&type=script&lang=js&"
export * from "./ShareSavingsReport.vue?vue&type=script&lang=js&"
import style0 from "./ShareSavingsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports